var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgService3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3710 3710",
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 3710,
    height: 3710
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3539.4087,
    y1: 3696.2283,
    x2: 1561.8756,
    y2: 1591.1129
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M2945.656,2851.665c-73.002,75.249-138.322,119.482-188.333,152.875 c-487.75,325.675-1045.302,231.808-1217.683,199.724c-278.116-51.763-512.884-88.28-714.592-270.515 c-458.341-414.093-436.048-1277.922-85.82-1813.027c41.526-63.448,391.225-581.809,949.984-654.851 c13.667-1.786,23.864-2.804,32.795-3.75c86.439-9.152,622.082-57.454,1058.846,308.467 c62.521,52.38,163.134,146.859,256.436,290.956C3378.44,1588.428,3379.521,2404.454,2945.656,2851.665z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145024733362524416080000008203450474218086589_",
    gradientUnits: "userSpaceOnUse",
    x1: 3394.7637,
    y1: 4189.5122,
    x2: 222.4789,
    y2: -616.9828
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145024733362524416080000008203450474218086589_)"
    },
    d: "M1154.718,585.579 c-66.674,5.798-117.793,61.638-117.983,128.564c-1.161,409.279-3.076,1820.992,23.601,2320.659 c2.826,52.936,46.224,94.52,99.232,95.091c262.177,2.823,1016.322,8.008,1444.453-19.377 c89.173-5.704,158.564-79.559,158.456-168.914c-0.52-429.553-7.384-1637.604-66.225-2189.79 c-7.05-66.16-60.233-117.802-126.567-122.971C2283.74,606.562,1524.41,553.427,1154.718,585.579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1141.976,821.401c-5.149,350.102-19.808,1514.746,5.782,1944.596 c3.74,62.828,52.544,112.431,112.805,114.531c248.114,8.647,884.36,25.379,1246.905-14.513 c65.282-7.183,115.176-63.768,116.915-132.286c9.069-357.278,33.565-1442.009,8.694-1867.052 c-3.968-67.806-55.771-121.911-120.709-126.286c-268.648-18.102-958.505-59.849-1266.8-34.175 C1187.695,711.036,1142.867,760.79,1141.976,821.401z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091703278559130172130000003707554455798253757_",
    gradientUnits: "userSpaceOnUse",
    x1: 1741.3406,
    y1: 649.1923,
    x2: 2020.2117,
    y2: 649.1923
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000091703278559130172130000003707554455798253757_)"
    },
    d: "M1741.448,646.451 c0.212,9.672,7.926,17.484,17.596,17.778c47.741,1.451,182.23,5.568,242.342,7.733c11.852,0.427,20.909-10.417,18.408-22.011 c-0.206-0.365-1.746-15.23-16.926-16.285c-40.663-2.828-163.339-10.45-244.407-5.773 C1741.813,628.854,1740.908,647.786,1741.448,646.451z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147204946289739160980000012173674607138189979_",
    gradientUnits: "userSpaceOnUse",
    x1: 1772.5642,
    y1: 2598.9338,
    x2: 3269.4429,
    y2: 765.5988
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000147204946289739160980000012173674607138189979_)"
    },
    d: "M1433.196,1878.683 c0,0,341.976-85.788,703.304-34.053c101.662,14.556,191.707,73.705,246.569,160.523 c98.851,156.429,238.605,435.19,209.043,725.922l-155.15,38.364c0,0-107.225-345.015-227.907-485.434 c0,0-142.925,325.782-135.697,504.68c0.204,5.056,0.529,9.996,0.979,14.807c16.401,175.029-686.08,32.66-686.08,32.66 L1433.196,1878.683z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170257432585053406370000002176883349601723549_",
    gradientUnits: "userSpaceOnUse",
    x1: 1752.4783,
    y1: 1798.0168,
    x2: 1745.3829,
    y2: 1315.5149,
    gradientTransform: "matrix(0.9329 0.3602 -0.3602 0.9329 756.8203 -140.6929)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170257432585053406370000002176883349601723549_)"
    },
    d: "M1802.902,1586.63l-72.807,231.91 c-6.773,21.574-0.036,44.678,16.881,57.706c38.969,30.014,115.996,77.796,210.107,76.424 c17.222-0.25,31.696-14.948,32.9-32.983l25.869-387.618L1802.902,1586.63z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000151538230129524241400000005461462700751985024_",
    gradientUnits: "userSpaceOnUse",
    x1: 12712.5684,
    y1: 1162.7728,
    x2: 12290.875,
    y2: 1485.4326,
    gradientTransform: "matrix(0.9672 0.2541 -0.2541 0.9672 -9938.2715 -2874.2493)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000151538230129524241400000005461462700751985024_)"
    },
    d: "M2084.812,1332.464 c0,0,28.283,182.636,10.473,269.916s-13.94,147.967-117.954,139.156c-104.015-8.811-174.784-80.374-197.664-177.988 c0,0-36.43-150.721-6.269-200.601C1803.559,1313.067,2084.812,1332.464,2084.812,1332.464z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182503259059007345740000002091516796794558106_",
    gradientUnits: "userSpaceOnUse",
    x1: 2032.8801,
    y1: 967.3642,
    x2: 1826.8881,
    y2: 1585.3424
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000182503259059007345740000002091516796794558106_)"
    },
    d: "M1829.842,1510.87l12.574,3.304 c0,0-23.887-119.879,26.54-126.588c50.427-6.709,240.407,3.897,296.122-49.863c53.712-51.827,41.198-140.291-2.988-175.737 c-2.795-2.243-6.92-1.734-9.344,0.906l-6.207,6.754c-4.25,4.626-11.97,1.728-12.125-4.553l0,0 c-0.148-5.956-7.293-9.126-11.624-5.034c-16.936,16.005-57.358,38.645-148.042,31.883 c-128.675-9.595-222.857,18.756-247.136,103.047c-1.538,5.34-8.059,6.792-11.914,2.79 c-7.609-7.902-21.427-14.302-45.085-3.101c-41.142,19.481-46.666,96.606,11.32,176.477c2.755,3.795,1.286,9.269-3.165,10.745 c-15.683,5.2-41.092,20.699,3.37,61.941c45.483,42.189,77.609,47.332,90.221,47.413c3.394,0.022,6.293-2.314,6.952-5.643 l15.105-76.383c0.781-3.95,4.732-6.424,8.626-5.401L1829.842,1510.87z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102532429147325923210000008878618062813897118_",
    gradientUnits: "userSpaceOnUse",
    x1: 12660.2637,
    y1: 1094.4091,
    x2: 12238.5693,
    y2: 1417.069,
    gradientTransform: "matrix(0.9672 0.2541 -0.2541 0.9672 -9938.2715 -2874.2493)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000102532429147325923210000008878618062813897118_)"
    },
    d: "M1828.799,1527.407 c0,0,0.289-111.842-54.361-94.821c-54.65,17.021-6.463,123.701,30.243,137.534L1828.799,1527.407z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141445405815522971640000016839857361104054418_",
    gradientUnits: "userSpaceOnUse",
    x1: 1400.2745,
    y1: 2294.9668,
    x2: 2897.1504,
    y2: 461.6351
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000141445405815522971640000016839857361104054418_)"
    },
    d: "M1447.465,2613.309 c-15.148-106.969,83.478-301.389,129.299-361.055c13.107-17.067,20.435-37.934,20.623-59.453 c1.34-151.494-62.272-248.787-164.19-314.119c0,0-369.912,430.959-275.723,762.441c10.162,35.772,25.913,66.507,45.883,92.917 C1218.2,2609.141,1374.713,2619.073,1447.465,2613.309z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072994211703518432160000003691620759936589702_",
    gradientUnits: "userSpaceOnUse",
    x1: 1296.5657,
    y1: 1483.2089,
    x2: 1687.9497,
    y2: 3192.9453
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072994211703518432160000003691620759936589702_)"
    },
    d: "M1442.215,2534.755l-14.094-1.607 c11.946-104.902,103.997-234.403,143.017-285.214l11.253,8.641C1544.092,2306.446,1453.767,2433.384,1442.215,2534.755z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165218295819144928470000000242118302833513659_",
    gradientUnits: "userSpaceOnUse",
    x1: 1403.78,
    y1: 2480.2708,
    x2: 1656.6187,
    y2: 3145.6353
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165218295819144928470000000242118302833513659_)"
    },
    d: "M1449.343,2608.291 c-41.608,0.069-233.001,6.621-250.674,120.812c165.075,218.327,620.085,139.558,620.085,139.558v-84.956 c0,0-285.224-51.796-357.728-168.904C1458.515,2610.747,1454.112,2608.283,1449.343,2608.291z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031886001588794460120000016731192896330034870_",
    gradientUnits: "userSpaceOnUse",
    x1: 1730.9702,
    y1: 2326.3718,
    x2: 2000.6095,
    y2: 3035.9485
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031886001588794460120000016731192896330034870_)"
    },
    d: "M1779.701,2850.147 c0,0,67.183-158.527,185.561-102.296c118.379,56.232,109.074,93.027,109.074,93.027L1779.701,2850.147z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170964428438894029970000003459033153780849832_",
    gradientUnits: "userSpaceOnUse",
    x1: 2009.7544,
    y1: 2996.5417,
    x2: 2359.9238,
    y2: 2471.2881
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170964428438894029970000003459033153780849832_)"
    },
    d: "M1764.61,2883.037L1764.61,2883.037 c0.94,11.995,11.162,21.12,23.186,20.701l613.431-21.4c9.534-0.332,17.82-6.649,20.665-15.755l17.805-56.975 c4.374-13.997-5.614-28.365-20.257-29.142l-223.697-11.883c-2.031-0.108-4.066,0.06-6.051,0.5l-407.539,90.258 C1771.216,2861.762,1763.734,2871.87,1764.61,2883.037z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000146487906747704278910000006826970627272370098_",
    gradientUnits: "userSpaceOnUse",
    x1: 2129.2744,
    y1: 3076.2212,
    x2: 2479.4441,
    y2: 2550.9673
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000146487906747704278910000006826970627272370098_)"
    },
    points: "2175.802,2860.652  2192.684,2782 2422.464,2792.965 2407.346,2858.222  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165950832244828472460000003492521436497367196_",
    gradientUnits: "userSpaceOnUse",
    x1: 2376.0591,
    y1: 2422.3569,
    x2: 3606.8008,
    y2: 1752.9166
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165950832244828472460000003492521436497367196_)"
    },
    d: "M2058.005,2014.07 c-13.004,106.262-71.507,537.997-88.252,661.354c-2.355,17.348,11.424,32.606,28.925,32.105l992.422-28.399 c12.987-0.371,24.061-9.519,26.877-22.203l154.381-695.248c4.082-18.38-10.551-35.563-29.347-34.462l-1058.513,61.999 C2070.811,1990.018,2059.671,2000.462,2058.005,2014.07z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101062764021068775650000006048475672373880218_",
    gradientUnits: "userSpaceOnUse",
    x1: 2511.8367,
    y1: 2195.9763,
    x2: 2491.238,
    y2: 2762.4282
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101062764021068775650000006048475672373880218_)"
    },
    d: "M2456.922,2450.065l-146.674,416.305 l341.055,7.229l28.398-421.035c1.333-19.758-15.054-36.161-34.813-34.849l-159.273,10.575 C2472.556,2429.157,2461.271,2437.721,2456.922,2450.065z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078755411459525654090000004567082532720723873_",
    gradientUnits: "userSpaceOnUse",
    x1: 2338.0974,
    y1: 3076.9382,
    x2: 2868.8953,
    y2: 2179.5081
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078755411459525654090000004567082532720723873_)"
    },
    d: "M2171.98,2872.301L2171.98,2872.301 c-3.759,11.455,4.775,23.237,16.831,23.237h534.11c9.783,0,17.714-7.931,17.714-17.714v-22.908 c0-10.08-8.401-18.129-18.473-17.697l-534.109,22.907C2180.682,2860.443,2174.28,2865.292,2171.98,2872.301z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2043.012,2453.281l-7.04-0.887l48.763-384.544c3.021-23.858,22.632-42.214,46.628-43.662 l914.723-55.242l0.43,7.082l-914.723,55.242c-20.594,1.24-37.426,16.998-40.018,37.468L2043.012,2453.281z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1978.368,
    y: 2600.448,
    transform: "matrix(0.125 -0.9922 0.9922 0.125 -815.7615 4283.02)",
    style: {
      fill: "#91B3FA"
    },
    width: 83.917,
    height: 7.096
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010296400328749093760000005882819058698827687_",
    gradientUnits: "userSpaceOnUse",
    x1: 1836.45,
    y1: 1860.8451,
    x2: 2002.1757,
    y2: 1748.4889,
    gradientTransform: "matrix(0.9856 -0.1691 0.1691 0.9856 -316.3687 156.5187)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000010296400328749093760000005882819058698827687_)"
    },
    d: "M1987.404,1645.31 c-110.209,8.326-174.267-105.63-174.902-106.785l7.382-4.063c0.609,1.103,62.128,110.36,166.885,102.447L1987.404,1645.31z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114769373144214246610000000742525641231383474_",
    gradientUnits: "userSpaceOnUse",
    x1: 1977.1414,
    y1: 1641.0533,
    x2: 2032.3308,
    y2: 1641.0533
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114769373144214246610000000742525641231383474_)"
    },
    d: "M2032.331,1641.053 c0,6.532-5.295,11.827-11.827,11.827h-31.536c-6.532,0-11.826-5.295-11.826-11.827l0,0c0-6.532,5.295-11.827,11.826-11.827 h31.536C2027.036,1629.227,2032.331,1634.522,2032.331,1641.053L2032.331,1641.053z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088108624443671419650000008410817224458317958_",
    gradientUnits: "userSpaceOnUse",
    x1: 2400.2976,
    y1: 1425.5779,
    x2: 1141.5438,
    y2: 1633.5457,
    gradientTransform: "matrix(0.9856 -0.1691 0.1691 0.9856 -316.3687 156.5187)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088108624443671419650000008410817224458317958_)"
    },
    d: "M1820.097,1412.113 c0,0,39.557-202.89,156.094-222.032c0,0-33.005-16.615-67.41,1.407c-34.405,18.022-121.368,116.775-117.822,225.625 C1814.615,1425.631,1820.097,1412.113,1820.097,1412.113z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096035721505913646510000013625540733775581351_",
    gradientUnits: "userSpaceOnUse",
    x1: 1988.131,
    y1: 1139.9873,
    x2: 1792.4385,
    y2: 1521.0729
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096035721505913646510000013625540733775581351_)"
    },
    d: "M1799.852,1402.509 c-60.585,12.296-53.137,88.912-53.137,88.912c-4.365,55.601,11.862,83.163,32.658,96.297 c14.206,8.973,32.091,9.803,47.09,2.235c14.999-7.57,24.934-22.45,26.171-39.207c1.119-15.131,2.4-29.515,3.524-34.623 C1858.878,1503.745,1860.438,1390.212,1799.852,1402.509z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000006673721821713797000000014648661113115459993_",
    gradientUnits: "userSpaceOnUse",
    x1: 1908.1644,
    y1: 1394.5364,
    x2: 2096.9905,
    y2: 1212.5767
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000006673721821713797000000014648661113115459993_)"
    },
    d: "M1805.417,1421.883 c-12.577-2.187-24.981,4.497-30.04,16.217c-36.209,83.88,8.249,138.445,30.073,139.583 c23.005,1.198,22.537-109.47,17.654-137.842C1821.057,1427.952,1813.504,1423.288,1805.417,1421.883z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 2679.776,
    cy: 1401.579,
    r: 373.436
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108287206412996477960000016227605987656273067_",
    gradientUnits: "userSpaceOnUse",
    x1: 2603.9526,
    y1: 626.79,
    x2: 2650.3015,
    y2: 1025.391
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000108287206412996477960000016227605987656273067_)"
    },
    d: "M2665.848,1636.305 c-17.589,1.151-33.952-7.032-43.057-21.651l-152.906-245.532c-14.33-23.009-6.609-54.525,17.237-70.387 c23.826-15.853,54.748-10.062,69.06,12.938l106.042,170.438l139.92-284.967c12.557-25.574,42.727-37.306,67.367-26.213 c24.636,11.088,34.439,40.792,21.9,66.349l-180.816,368.557c-8.28,16.875-24.74,28.488-42.981,30.322 C2667.025,1636.216,2666.437,1636.266,2665.848,1636.305z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039835940607730533770000018012239549723274676_",
    gradientUnits: "userSpaceOnUse",
    x1: -2249.0601,
    y1: 2473.4832,
    x2: -179.3282,
    y2: 3917.4824,
    gradientTransform: "matrix(-1 0 0 1 -644.2802 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039835940607730533770000018012239549723274676_)"
    },
    d: "M1461.986,3142.803v-442.927 c0-58.194-46.767-105.545-104.958-106.179c-174.644-1.902-534.839-1.996-829.556,22.839 c-40.217,3.388-71.499,36.351-72.957,76.684l-27.545,428.221c-2.047,56.641,42.734,103.962,99.402,105.038l834.175,15.852 C1416.256,3243.39,1461.986,3198.521,1461.986,3142.803z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1360.834,2747.799c0.742,37.688-0.376,97.487-1.293,136.121 c-0.476,20.1-18.123,35.417-38.092,33.077l-143.726-16.845c-19.147-2.244-32.636-19.891-29.779-38.956l17.642-117.689 c2.505-16.708,16.857-29.069,33.752-29.069h127.374C1345.271,2714.438,1360.468,2729.242,1360.834,2747.799z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.37,
      fill: "#FFFFFF"
    },
    d: "M985.229,2970.837l-119.894,12.934c-16.777,1.812-31.092-12.025-29.856-28.854 l26.211-356.648c50.259-1.594,99.833-2.756,147.669-3.572v349.265C1009.359,2957.769,998.956,2969.356,985.229,2970.837z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M936.089,2909.022c-0.369,6.416-5.684,11.362-12.028,11.362c-0.236,0-0.472-0.008-0.707-0.024 c-6.65-0.385-11.73-6.085-11.337-12.735l18.078-311.27c8.107-0.2,16.147-0.381,24.187-0.56L936.089,2909.022z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137125801702598250250000006932211162979552396_",
    gradientUnits: "userSpaceOnUse",
    x1: -1893.1522,
    y1: 2736.4812,
    x2: -2150.4304,
    y2: 3110.3381,
    gradientTransform: "matrix(-1 0 0 1 -644.2802 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137125801702598250250000006932211162979552396_)"
    },
    d: "M1294.365,2860.148 c2.104,0,3.878-1.633,4.012-3.769l6.218-98.041c0.141-2.214-1.539-4.122-3.761-4.264c-2.332-0.181-4.122,1.547-4.264,3.761 l-6.218,98.042c-0.141,2.214,1.539,4.121,3.761,4.263C1294.2,2860.148,1294.287,2860.148,1294.365,2860.148z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011738200404430066430000009782759276862948265_",
    gradientUnits: "userSpaceOnUse",
    x1: -1883.9011,
    y1: 2742.8479,
    x2: -2141.1797,
    y2: 3116.7051,
    gradientTransform: "matrix(-1 0 0 1 -644.2802 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011738200404430066430000009782759276862948265_)"
    },
    d: "M1281.568,2860.148 c2.159,0,3.949-1.711,4.02-3.887l3.258-99.917c0.07-2.222-1.672-4.083-3.886-4.154c-2.561-0.125-4.075,1.673-4.154,3.887 l-3.259,99.918c-0.071,2.222,1.673,4.083,3.887,4.154C1281.434,2860.148,1281.527,2860.148,1281.568,2860.148z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127726246047305508910000006880277732733224593_",
    gradientUnits: "userSpaceOnUse",
    x1: -1872.7391,
    y1: 2750.5291,
    x2: -2130.0178,
    y2: 3124.3865,
    gradientTransform: "matrix(-1 0 0 1 -644.2802 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127726246047305508910000006880277732733224593_)"
    },
    d: "M1264.215,2860.139 c-2.222-0.102-3.933-1.986-3.824-4.2c1.594-33.566,4.633-97.587,4.679-99.769c0.016-2.199,1.814-3.981,4.02-3.981 c2.222,0,4.02,1.798,4.02,4.02c0,1.656-3.91,83.681-4.695,100.106c-0.102,2.159-1.877,3.832-4.013,3.832 C1264.341,2860.148,1264.278,2860.148,1264.215,2860.139z M1264.993,2756.209h0.078H1264.993z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163775046422467884080000009860176632407518849_",
    gradientUnits: "userSpaceOnUse",
    x1: -1853.4324,
    y1: 2763.8157,
    x2: -2110.7102,
    y2: 3137.6719,
    gradientTransform: "matrix(-1 0 0 1 -644.2802 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163775046422467884080000009860176632407518849_)"
    },
    d: "M1237.607,2864.167 c4.312,0,7.876-3.416,8.025-7.757c3.4-96.809,2.803-98.992,2.411-100.437c-1.162-4.294-5.622-6.814-9.87-5.645 c-3.934,1.076-6.391,4.892-5.857,8.825c0.259,5.818-1.539,62.145-2.748,96.691c-0.157,4.436,3.313,8.166,7.749,8.315 C1237.411,2864.167,1237.513,2864.167,1237.607,2864.167z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065032230852018544840000017226235181394746542_",
    gradientUnits: "userSpaceOnUse",
    x1: -1840.7018,
    y1: 2772.5764,
    x2: -2097.98,
    y2: 3146.4333,
    gradientTransform: "matrix(-1 0 0 1 -644.2802 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065032230852018544840000017226235181394746542_)"
    },
    d: "M1220.184,2860.148 c2.223,0,4.02-1.798,4.02-4.021v-98.041c0-2.223-1.798-4.02-4.02-4.02c-2.222,0-4.019,1.798-4.019,4.02v98.041 C1216.165,2858.35,1217.962,2860.148,1220.184,2860.148z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103226759789226218330000013179365457136185252_",
    gradientUnits: "userSpaceOnUse",
    x1: -1832.7987,
    y1: 2778.0156,
    x2: -2090.0752,
    y2: 3151.8701,
    gradientTransform: "matrix(-1 0 0 1 -644.2802 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103226759789226218330000013179365457136185252_)"
    },
    d: "M1206.115,2860.148 c2.182,0,3.973-1.743,4.02-3.927c0.77-34.067,2.568-89.711,4.177-96.4c0.706-1.264,0.698-2.866-0.149-4.169 c-1.217-1.868-3.706-2.371-5.567-1.154c-2.191,1.436-4.271,2.795-6.501,101.535c-0.047,2.222,1.711,4.059,3.926,4.115H1206.115 z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054985162680916267890000010881807729021058702_",
    gradientUnits: "userSpaceOnUse",
    x1: -1906.3901,
    y1: 2727.3721,
    x2: -2163.6672,
    y2: 3101.2275,
    gradientTransform: "matrix(-1 0 0 1 -644.2802 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054985162680916267890000010881807729021058702_)"
    },
    d: "M1315.996,2869.074 c4.248,0,7.797-3.329,8.025-7.624l5.362-102.949c0.228-4.436-3.18-8.212-7.616-8.448c-4.208-0.298-8.213,3.18-8.448,7.616 l-5.362,102.949c-0.228,4.436,3.179,8.213,7.615,8.448C1315.713,2869.074,1315.855,2869.074,1315.996,2869.074z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011006478798498847510000013396744999274200971_",
    gradientUnits: "userSpaceOnUse",
    x1: -1956.5543,
    y1: 2094.644,
    x2: -503.032,
    y2: 3108.7295,
    gradientTransform: "matrix(-1 0 0 1 -644.2802 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011006478798498847510000013396744999274200971_)"
    },
    d: "M1242.511,2543.4v-311.057 c0-40.868-32.843-74.121-73.709-74.566c-122.649-1.335-375.605-1.402-582.578,16.039c-28.243,2.38-50.212,25.529-51.236,53.854 l-19.344,300.729c-1.438,39.778,30.011,73.01,69.807,73.766l585.821,11.132C1210.396,2614.04,1242.511,2582.529,1242.511,2543.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1171.474,2265.999c0.522,26.468-0.264,68.463-0.908,95.595 c-0.335,14.115-12.727,24.873-26.752,23.229l-100.935-11.83c-13.446-1.575-22.92-13.968-20.913-27.357l12.389-82.651 c1.759-11.733,11.839-20.414,23.703-20.414h89.452C1160.545,2242.57,1171.217,2252.966,1171.474,2265.999z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.37,
      fill: "#FFFFFF"
    },
    d: "M907.696,2422.633l-84.199,9.083c-11.781,1.272-21.834-8.445-20.966-20.263 l18.407-250.465c35.296-1.119,70.111-1.935,103.704-2.509v245.281C924.642,2413.455,917.336,2421.592,907.696,2422.633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M873.186,2379.222c-0.259,4.505-3.992,7.979-8.447,7.979c-0.166,0-0.332-0.006-0.497-0.017 c-4.67-0.27-8.237-4.273-7.962-8.943l12.696-218.597c5.693-0.141,11.339-0.268,16.985-0.393L873.186,2379.222z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000068679650810394389050000016939365734849659009_",
    gradientUnits: "userSpaceOnUse",
    x1: -1737.126,
    y1: 2258.0503,
    x2: -1917.8059,
    y2: 2520.6003,
    gradientTransform: "matrix(-1 0 0 1 -644.2802 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000068679650810394389050000016939365734849659009_)"
    },
    d: "M1124.795,2344.898 c1.478,0,2.724-1.146,2.818-2.647l4.366-68.851c0.099-1.555-1.081-2.895-2.641-2.994c-1.638-0.127-2.895,1.085-2.994,2.641 l-4.367,68.853c-0.099,1.555,1.081,2.895,2.642,2.994C1124.679,2344.898,1124.74,2344.898,1124.795,2344.898z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083775960799344164450000011601243020517476768_",
    gradientUnits: "userSpaceOnUse",
    x1: -1730.6294,
    y1: 2262.5212,
    x2: -1911.3094,
    y2: 2525.0715,
    gradientTransform: "matrix(-1 0 0 1 -644.2802 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083775960799344164450000011601243020517476768_)"
    },
    d: "M1115.807,2344.898 c1.516,0,2.773-1.202,2.823-2.729l2.288-70.17c0.05-1.561-1.174-2.867-2.729-2.917c-1.798-0.088-2.862,1.175-2.917,2.729 l-2.289,70.17c-0.05,1.56,1.175,2.867,2.73,2.917C1115.713,2344.898,1115.779,2344.898,1115.807,2344.898z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085937990971032836000000007503158784586766262_",
    gradientUnits: "userSpaceOnUse",
    x1: -1722.7905,
    y1: 2267.9155,
    x2: -1903.4709,
    y2: 2530.4666,
    gradientTransform: "matrix(-1 0 0 1 -644.2802 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085937990971032836000000007503158784586766262_)"
    },
    d: "M1103.621,2344.893 c-1.56-0.072-2.762-1.395-2.685-2.95c1.119-23.572,3.253-68.532,3.286-70.065c0.012-1.544,1.275-2.796,2.823-2.796 c1.561,0,2.824,1.263,2.824,2.823c0,1.164-2.746,58.768-3.297,70.303c-0.072,1.516-1.318,2.691-2.818,2.691 C1103.71,2344.898,1103.665,2344.898,1103.621,2344.893z M1104.167,2271.905h0.055H1104.167z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047025346584075527150000007036627628796869563_",
    gradientUnits: "userSpaceOnUse",
    x1: -1709.2318,
    y1: 2277.2466,
    x2: -1889.9117,
    y2: 2539.7969,
    gradientTransform: "matrix(-1 0 0 1 -644.2802 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047025346584075527150000007036627628796869563_)"
    },
    d: "M1084.935,2347.721 c3.027,0,5.531-2.399,5.635-5.448c2.388-67.986,1.969-69.52,1.693-70.534c-0.816-3.016-3.948-4.786-6.931-3.965 c-2.763,0.755-4.488,3.435-4.113,6.197c0.181,4.086-1.081,43.643-1.93,67.904c-0.11,3.115,2.327,5.735,5.442,5.839 C1084.797,2347.721,1084.869,2347.721,1084.935,2347.721z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141425682519386349920000007196723955468736412_",
    gradientUnits: "userSpaceOnUse",
    x1: -1700.2915,
    y1: 2283.3989,
    x2: -1880.9717,
    y2: 2545.9492,
    gradientTransform: "matrix(-1 0 0 1 -644.2802 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000141425682519386349920000007196723955468736412_)"
    },
    d: "M1072.699,2344.898 c1.561,0,2.824-1.262,2.824-2.824v-68.851c0-1.561-1.263-2.823-2.824-2.823c-1.56,0-2.822,1.263-2.822,2.823v68.851 C1069.877,2343.635,1071.139,2344.898,1072.699,2344.898z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000161597497958226909540000000384586644910158001_",
    gradientUnits: "userSpaceOnUse",
    x1: -1694.7412,
    y1: 2287.2188,
    x2: -1875.4203,
    y2: 2549.7678,
    gradientTransform: "matrix(-1 0 0 1 -644.2802 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000161597497958226909540000000384586644910158001_)"
    },
    d: "M1062.818,2344.898 c1.533,0,2.79-1.224,2.823-2.757c0.541-23.925,1.804-63.002,2.933-67.7c0.496-0.887,0.491-2.013-0.105-2.928 c-0.855-1.312-2.603-1.665-3.909-0.81c-1.538,1.008-3,1.963-4.566,71.306c-0.032,1.561,1.202,2.851,2.757,2.889H1062.818z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083786070395658964300000016568262093901271181_",
    gradientUnits: "userSpaceOnUse",
    x1: -1746.4226,
    y1: 2251.6531,
    x2: -1927.1027,
    y2: 2514.2034,
    gradientTransform: "matrix(-1 0 0 1 -644.2802 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083786070395658964300000016568262093901271181_)"
    },
    d: "M1139.986,2351.167 c2.983,0,5.476-2.338,5.635-5.354l3.766-72.298c0.16-3.115-2.233-5.768-5.348-5.933c-2.955-0.209-5.768,2.234-5.933,5.349 l-3.766,72.298c-0.16,3.115,2.233,5.767,5.348,5.933C1139.787,2351.167,1139.886,2351.167,1139.986,2351.167z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgService3);
export default __webpack_public_path__ + "static/media/service3.831138861e866eff5e616ea5ebe0e363.svg";
export { ForwardRef as ReactComponent };